import React from "react";

import { useFacilityReportSelectItems } from "./hook";
import DropdownSelect from "../../../FormElement/DropdownSelect";

type IFacilityReportSelectProps = {
  locationId: string;
  currentReportId: number;
  onSelectId: (id: number) => void;
};

export const FacilityReportSelect: React.FunctionComponent<
  IFacilityReportSelectProps
> = (props) => {
  const { locationId, currentReportId, onSelectId } = props;

  const { items, selectedItem, getIdForItem } = useFacilityReportSelectItems(
    locationId,
    currentReportId
  );

  const onChange = (item: string) => onSelectId(getIdForItem(item));

  return (
    <div className="facility-report-select">
      <DropdownSelect
        value={selectedItem}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};
